import { useIsMobile } from '@/hooks/use-media-query';
import MessengerChatDesktop from './MessengerChatDesktop';
import MobileChat from '@/pages/mobile/MobileChat';

// Task #1719 — Dispatcher Messenger Chat: scelta esperienza in base al
// viewport. La logica desktop vive in `MessengerChatDesktop` (estratta dal
// vecchio monolite), quella mobile in `pages/mobile/MobileChat` (push nav
// fullscreen + composer con keyboard inset). Niente shortcut globali registrati
// lato mobile (gestiti solo nel ramo desktop).
export default function MessengerChat() {
  const isMobile = useIsMobile();
  return isMobile ? <MobileChat /> : <MessengerChatDesktop />;
}
